const GamesAndSoftware = ({ games, softwareProviders, name }) => {
  return (
    <section className="mt-12 max-w-[1440px] mx-auto px-5 sm:px-8 md:px-12 lg:px-16 xl:px-20 pb-16 transition-colors duration-300">
      {/* Header */}
      <div className="mb-6 text-left">
        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
          Games & Software
        </h2>
        <hr className="border-t-[1px] border-gray-400 dark:border-gray-600 mb-3" />
        <p className="text-gray-600 dark:text-gray-300">
          Explore the extensive game offering that {name} has to offer.
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-8">
        {/* LEFT COLUMN */}
        <div className="flex flex-col gap-8 w-full lg:w-[60%]">
          {/* ✅ Expanded Game Categories */}
          <div className="bg-white dark:bg-[#1e2430] border border-gray-300 dark:border-gray-600 rounded-2xl p-10 transition-colors duration-300">
            <h3 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-8 text-left">
              Game Categories
            </h3>

            <div className="grid grid-cols-2 gap-6">
              {games.map((item, i) => (
                <div
                  key={i}
                  className="flex flex-col  md:flex-row md:justify-between items-center  border border-gray-300 dark:border-gray-600 rounded-2xl px-10 py-6 transition-all duration-300 bg-white dark:bg-[#1e2430] hover:shadow-md"
                >
                  <span className="font-semibold  text-[17px] text-gray-900 dark:text-gray-100">
                    {item.label}
                  </span>
                  <span className="text-[16px] text-gray-600 dark:text-gray-400">
                    {item.count}+
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="bg-white dark:bg-[#1e2430] border border-gray-300 dark:border-gray-600 rounded-2xl p-8 h-fit w-full lg:w-[40%] transition-colors duration-300">
          <h3 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-6 text-left">
            Software Providers
          </h3>

          {/* Providers List */}
          <div className="flex flex-wrap gap-2 text-[12.5px] font-semibold text-gray-900 dark:text-gray-100">
            {softwareProviders.map((provider, j) => (
              <span
                key={j}
                className="px-3 py-1 rounded-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-[#1e2430] transition-colors duration-300"
              >
                {provider.label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GamesAndSoftware;
